export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'defaultImageUrl',
    width: 70,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' }
  },
  {
    title: that.$l('INDEX.amz_sku_inv_goodsName') || '产品',
    field: 'goodsName',
    minWidth: 300,
    fixed: 'left',
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' }
  },
  {
    title: that.$l('INDEX.amz_sku_inv_scmName') || '工厂',
    field: 'scmName',
    minWidth: 260,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayScmName' }
  },
  {
    title: that.$l('INDEX.amz_sku_inv_ftyPrice') || '采购单价',
    field: 'ftyPrice',
    minWidth: 80,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.amz_sku_inv_inCtnQty') || '箱入数',
    field: 'inCtnQty',
    minWidth: 60,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.amz_sku_inv_ctnQty') || '箱数',
    field: 'ctnQty',
    minWidth: 120,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'ctnQty' }
  },
  {
    title: that.$l('form_label_ftyInvQty') || '产品数量',
    field: 'ftyInvQty',
    minWidth: 120,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'ftyInvQty' }
  },
  {
    title: that.$l('INDEX.amz_sku_inv_ftyInvAmount') || '库存金额',
    field: 'ftyInvAmount',
    minWidth: 120,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.amz_sku_inv_ftyInvUpdateTime') || '国内库存更新时间',
    field: 'ftyInvUpdateTime',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true
  }
]
